import React, { useEffect, useState } from 'react';
import { Table, Button, Input, Form, notification } from 'antd';
import EOLService from '../../services/EOLService';

const EditQty = ({ selectedBin,
  dispatchArea,
  userData,
  editValue,
  handleArrowClick,
  binFull }) => {
  // console.log(editValue);

  const [dataSource, setDataSource] = useState(editValue);
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDataSource(editValue);
  }, [editValue]);

  const tableStyle = {
    backgroundColor: '#9F5375',
    color: '#ffffff',
    padding: '3px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '50%',
    margin: '0 auto',
  };

  const columns = [
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size',
      width: 170,
      render: (text) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <span style={{ fontWeight: 'bold', fontSize: '15px' }}>
            {text}
          </span>
        </div>
      ),
    },
    {
      title: 'Total Quantity',
      dataIndex: 'totalQty',
      key: 'totalQty',
      width: 160,
      render: (text) => (
        <div
          style={tableStyle}
        >
          {text}
        </div>
      ),
    },
    {
      title: 'Available Quantity',
      dataIndex: 'availableQty',
      key: 'availableQty',
      width: 160,
      render: (text) => (
        <div
          style={tableStyle}
        >
          {text}
        </div>
      ),
    },
    {
      title: 'Enter Quantity',
      dataIndex: 'enterQty',
      key: 'enterQty',
      width: 200,
    },
  ];

  const handleSubmit = async () => {
    console.log(selectedBin, dispatchArea);

    setLoading(true);

    const updatedData = dataSource.map((item) => {
      if (item.enterQty !== undefined) {
        return {
          ...item,
          // avilableQty: item.enterQty,
        };
      }
      return item;
    });

    const size = updatedData
      .filter((data) => data.enterQty !== undefined)
      .reduce((acc, data) => {
        acc[data.size] = data.enterQty;
        return JSON.stringify(acc);
      }, {});

    console.log(size);

    const missingQtyItems = dataSource.filter((item) => !item.enterQty);

    if (missingQtyItems.length > 1) {
      openNotificationWithIcon("error", "Please enter Vaild Quantity.");
      setLoading(false);
      return;
    }

    if (!dispatchArea) {
      openNotificationWithIcon('warning', 'Please select a Required Area.');
      setLoading(false);
      return;
    }

    if (dispatchArea === "Washing" && !selectedBin) {
      openNotificationWithIcon('warning', 'Please select a Bin.');
      setLoading(false);
      return;
    }

    const hasNonZeroSize = Object.values(size).some(value => Number(value) > 0);

    if (!hasNonZeroSize) {
      console.log("No size found");
      openNotificationWithIcon('error', 'No size found. Please enter a valid quantity.');
      setLoading(false);
      return;
    }


    try {
      console.log("pass condition ");
      const response = await EOLService.add_eol_dispatch(size, userData, dispatchArea, editValue, selectedBin, binFull);

      // Display the success notification
      openNotificationWithIcon('success', response.message);

      setTimeout(() => {
        handleArrowClick();
        setLoading(false);
      }, 800);
    } catch (error) {
      // Handle errors and show an error notification
      console.error('Error submitting EOL dispatch:', error);
      openNotificationWithIcon('error', 'Failed to submit EOL dispatch. Please try again.');
      setLoading(false);
    }
  };


  const openNotificationWithIcon = (type, message) => {
    const messages = {
      error: {
        message: 'Error',
        description: message,
      },
      success: {
        message: 'Success',
        description: message,
      },
      warning: {
        message: 'Warning',
        description: message,
      },
    };

    api[type](messages[type]);
  };

  const columnsWithEditable = columns.map((col) => {
    if (col.dataIndex === 'enterQty') {
      return {
        ...col,
        editable: true,
        render: (_, record) => {
          return (
            <div style={{ width: 90, margin: '0 auto', }}>
              <Input
                value={record.enterQty}
                onChange={(e) => {
                  const value = e.target.value;

                  if (value !== "" && !/^\d*$/.test(value)) {
                    return;
                  }

                  const numericValue = Number(value);

                  const currentItem = dataSource.find(item => item.key === record.key);

                  if (currentItem && numericValue > currentItem.availableQty) {
                    openNotificationWithIcon(
                      "error",
                      `Quantity cannot be greater than ${currentItem.availableQty}`
                    );
                    return;
                  }

                  const updatedData = [...dataSource];
                  const index = updatedData.findIndex(item => item.key === record.key);
                  if (index !== -1) {
                    updatedData[index].enterQty = value;
                    setDataSource(updatedData);
                  }
                }}
                required
              />

            </div>
          );
        },
      };
    }
    return col;
  });

  return (
    <div>
      {contextHolder}
      <Table
        size='small'
        style={{ width: '80%' }}
        dataSource={dataSource}
        columns={columnsWithEditable}
        pagination={false}
        rowClassName="editable-row"
        components={{
          header: {
            cell: (props) => (
              <th
                {...props}
                style={{
                  textAlign: "center",
                }}
              >
                {props.children}
              </th>
            ),
          },
        }}
        footer={() => (
          dataSource.length > 0 ? (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                type="primary"
                style={{ marginRight: '8px' }}
                onClick={handleSubmit}
                loading={loading}
              >
                Submit
              </Button>
              <Button onClick={handleArrowClick}>Cancel</Button>
            </div>
          ) : null
        )}
      />
    </div>
  );
};

export default EditQty;